import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/dashboard/Dashboard.vue'
import Projects from '../views/projects/Projects.vue'
import TasksProject from "../views/projects/TasksProject";
import Team from "../views/team/Team";
import Login from "../views/login/Login";
import ResetPassword from "../views/login/ResetPassword";
import Customers from "../views/customers/Customers";
import Providers from "../views/providers/Providers";
import Tasks from "../views/tasks/Tasks";
import Tasks2 from "../views/tasks/Tasks2";
import Settings from "../views/settings/Settings";

Vue.use(VueRouter)

// {
//   path: '/',
//       name: 'dashboard',
//     component: Dashboard,
//     meta: {
//   breadCrumb: [
//     {
//       text: 'Home'
//     }
//   ]
// }
// },
// {
//   path: '/projects',
//       name: 'projects',
//     component: Projects,
//     meta: {
//   breadCrumb(route: Route) {
//     const paramToPageB = route.params.paramToPageB;
//     return [
//       {
//         text: 'Home',
//         to: { name: 'Home' }
//       },
//       {
//         text: paramToPageB,
//       }
//     ]}
// }
// },

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: ResetPassword
  },
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
  },
  {
    path: '/projects',
    name: 'projects',
    component: Projects
  },
  {
    path: '/projects/:anno_riferimento',
    name: 'backup',
    component: Projects
  },
  {
    path: '/project/:projectId',
    name: 'detailsProject',
    component: Projects,
    props: true,
  },
  {
    path: '/project/:projectId/tasks',
    name: 'tasksProject',
    component: TasksProject,
    props: true,
  },
  {
    path: '/project/:projectId/tasks2',
    name: 'tasksProject2',
    component: () => import('../views/projects/TasksProject2.vue'),
    props: true,
  },
  {
    path: '/team',
    name: 'team',
    component: Team
  },
  {
    path: '/customers',
    name: 'customers',
    component: Customers
  },
  {
    path: '/providers',
    name: 'providers',
    component: Providers
  },
  {
    path: '/tasks',
    name: 'tasks',
    component: Tasks
  },
  {
    path: '/tasks2',
    name: 'tasks2',
    component: Tasks2
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings
  },
  {
    path: '/admin/permissions',
    name: 'admin-permissions',
    component: () => import('../views/admin/PermissionsPage.vue'),
    meta: {
      requiresAdmin: true
    }
  },

]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const token = JSON.parse(window.localStorage.getItem('token'))
  if (!token && to.name !== 'login' && to.name !== 'reset-password') {
    next({name: 'login'})
    return
  }

  // Controllo permessi admin
  if (to.meta.requiresAdmin) {
    const user = JSON.parse(window.localStorage.getItem('user'))
    if (!user || user.role !== 'ADMIN') {
      next({name: 'dashboard'})
      return
    }
  }

  next();
})
export default router
